<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="flgrow">
          <div class="input-group">
            <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" type="reset" class="add-button btn btn-primary"
        translate aria-label="Center Align">lblAddDiagnoseCheckList</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
            lblDiagnoseChecklist
        </div>
        <div class="table-responsive">

        
        <table class="tablest1 table-hover">
          <thead>
            <tr>
              <th style="width:30px" scope="col"> </th>
              <th style="width:55px" scope="col">#</th>
              <th style="width:15%" scope="col" sortable="subCheckListTitle" (sort)="onSort($event)" translate>
                lblCheckList
              </th>
              <th  scope="col" translate>lblCheckListDescription</th>
              <th style="width:150px" class="text-center" scope="col" translate>lblAction
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="checkList && checkList.length>0;else load_else" class="mb-3">
              <ng-container *ngFor="let check of checkList; let i=index" class="mb-3">
                <tr  style="cursor: pointer;" [ngClass]="{'bg-info': check.expanded}">
                  <td style="width:30px" class="pr-0" (click)="check.expanded = !check.expanded">
                    <a class="btn btn-ico" ngbTooltip="Show CheckList Item" tooltipClass="custom-revert" >
                        <em class="fas fa-chevron-right fa-lg" [ngClass]="{'fa-chevron-up': check.expanded}"></em>
                    </a>
                  </td> 
                  <td>{{ i+1 }}</td>
                  <td>
                    <ngb-highlight [result]="check.subCheckListTitle" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="check.checkListDescription" [term]="pService.searchTerm">
                    </ngb-highlight>
                  </td>
                  <td class="nowrap text-center">
                    <a class="btn btn-ico" ngbTooltip="{{'lblAdd' | translate}}" *ngIf="userRoleRightsDetails.canAdd"   (click)="onAdditem(check)">
                      <em class="fas fa-plus fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canEdit"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit" (click)="editCheckList(check.id)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete" (click)="deleteCheckList(check.id)">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                    
                  </td>
                </tr>
                <ng-container *ngIf="check.expanded">
                  <tr class="table-active">
                    <td colspan="5" class="p-2 pl47">
                      
                      <table class="tablest1 border">
                        <tr class="checkListItems" *ngIf="check.checkListItems.length>0;else load_else">
                    
                          <th style="width:40px" scope="col">#</th>
                          <th translate scope="col">lblCheckListItemTitle</th>
                          <th style="width:140px" scope="col" class="text-center" translate>lblAction</th>
      
                        </tr> 
                        <tr *ngFor="let item of check.checkListItems; let i=index" class="checkListItems">
                          
                          <td>{{ i+1 }}</td>
                          <td >{{item.subCheckListItemTitle}}</td>
                          <td class="nowrap text-right pr-1">
                            <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canEdit" (click)="editCheckListItem(check,item.id)">
                              <em class="fas fa-pencil-alt fa-lg" ></em>
                            </a> 
                            <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                            <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" *ngIf="userRoleRightsDetails.canDelete" (click)="deleteCheckList(item.id)">
                              <em class="far fa-trash-alt fa-lg" ></em>
                            </a> 
                            
                            
                          </td>
                          
                        </tr>                     
                      </table>

                    </td>
                  </tr>
                  
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #load_else>
              <tr>
                <td colspan="4" class="no-record" translate>lblNoRecordsFound</td>
              </tr>
            </ng-template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex justify-content-between">
          <div class="d-flex justify-content-between">
            <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
              [pageSize]="pService.pageSize" [maxSize]="3">
            </ngb-pagination>
            <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
              <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
              </option>
            </select>
          </div>
          <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
            <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$  | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
          </div>
  
        </div>
      </div>
     
     
      </div>
      
    </div>
  </div>
</div>